import React from "react";

import AgroTradeHeader from "../components/Header";
import LandingFooter from "../../landing/components/Footer";

function ExchangePage() {
    return (
        <div className="def_background min-h-screen flex flex-col">
            <AgroTradeHeader />
            <main className="flex-1">
                <div className="max-w-[1200px] mx-auto w-full px-4 py-10 lg:px-0">
                    <h1 className="text-2xl font-semibold mb-4">Агро биржа</h1>
                    <p className="text-sm text-[#4b5563]">
                        Статическое описание раздела «Агро биржа»: торги, заявки, котировки и инструменты
                        для участников рынка.
                    </p>
                </div>
            </main>
            <LandingFooter />
        </div>
    );
}

export default ExchangePage;

